import { render, staticRenderFns } from "./uploadImgDetail.vue?vue&type=template&id=1b46c628&scoped=true"
import script from "./uploadImgDetail.vue?vue&type=script&lang=js"
export * from "./uploadImgDetail.vue?vue&type=script&lang=js"
import style0 from "./uploadImgDetail.vue?vue&type=style&index=0&id=1b46c628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46c628",
  null
  
)

export default component.exports